"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Bookmark = _interopRequireDefault(require("@material-ui/icons/Bookmark"));

var _BookmarkBorder = _interopRequireDefault(require("@material-ui/icons/BookmarkBorder"));

var _BookmarkButtonModule = _interopRequireDefault(require("./BookmarkButton.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * # Bookmark Button
 * Simple Foodbomb Button with Heart Component
 *
 * ## Modifiers
 *
 * ### IsBookmarked
 * ```
 * [true, false]
 * ```
 *
 * ## PropTypes:
 * ```js
 * BookmarkButton.propTypes = {
 *    onClick: PropTypes.func,
 *    isBookmarked: PropTypes.bool,
 *    className: PropTypes.string,
 *  };
 * ```
 */
var BookmarkButton = function BookmarkButton(_ref) {
  var onClick = _ref.onClick,
      isBookmarked = _ref.isBookmarked,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["onClick", "isBookmarked", "className"]);

  var ButtonStyles = [_BookmarkButtonModule.default.Button];

  if (isBookmarked) {
    ButtonStyles.push(_BookmarkButtonModule.default.clicked);
  }

  if (!onClick) {
    ButtonStyles.push(_BookmarkButtonModule.default.inactive);
  }

  ButtonStyles.push(className);
  return /*#__PURE__*/_react.default.createElement(_core.IconButton, _extends({
    onClick: onClick,
    className: ButtonStyles.join(' '),
    "aria-label": "delete"
  }, props), isBookmarked ? /*#__PURE__*/_react.default.createElement(_Bookmark.default, {
    className: _BookmarkButtonModule.default.Icon
  }) : /*#__PURE__*/_react.default.createElement(_BookmarkBorder.default, {
    className: _BookmarkButtonModule.default.Icon
  }));
};

BookmarkButton.propTypes = {
  onClick: _propTypes.default.func,
  isBookmarked: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = BookmarkButton;
exports.default = _default;

//# sourceMappingURL=BookmarkButton.js.map